var _templateObject;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from 'styled-components';
import Layout from '../Layout';
var Wrapper = styled(Layout)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
export function Page(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]); // TODO add a hook to verify that only one Page is used and that it is just below the root element (or two below body)


  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    constrainWidth: false,
    disableGutter: true
  }, rest), React.Children.map(children, function (child) {
    return child && /*#__PURE__*/React.cloneElement(child, {
      isPageChild: true
    });
  }));
}
Page.defaultProps = {
  background: 'default'
};
export default Page;